import React from "react";
import { Container } from "reactstrap";
import { Link as RouterLink } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import { getPayloadMedia } from "../../services/payloadService";
import parseHtml from "../../utils/parseHtml";

export default function CTASection({ data, configuracion }) {
    const { titulo, descripcion, imagenFondo, imagenOpcional, tipoBoton, botonTexto, botonUrl, blockType, __component } = data;
    const ancla = blockType || __component?.split('.')[1] || 'cta';

    return (
        <section
            className="section"
            id={ancla}
            style={{background: imagenFondo ? `url(${getPayloadMedia(imagenFondo.url || imagenFondo[0]?.url)}) center no-repeat` : '', backgroundSize: 'cover' }}
        >
            <div className="bg-overlay"></div>
            <Container>
                <div className="row justify-content-center">
                    <div className="col">
                        <div className="section-title">
                            <h4 className="title text-white mb-3">{parseHtml(titulo)}</h4>
                            {descripcion && (
                                <p className="text-white para-desc mb-0">{parseHtml(descripcion)}</p>
                            )}
                            <div className="row g-2 g-md-4">
                            {tipoBoton === 'whatsapp' ? (
                                <div className="col-auto mt-4 mt-lg-5 pt-2">
                                   <a 
                                    href={`https://wa.me/${configuracion?.telefono?.replace(/\D/g, '')}?text=${encodeURIComponent('Hola, quiero cotizar este servicio')}`} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className={'btn btn-success'}
                                    >
                                     <i className="uil uil-whatsapp me-2" style={{fontSize: '20px'}}></i>
                                    {botonTexto || 'Cotizar'}
                                  </a>
                                </div>
                            ) : (
                                botonTexto && (
                                <div className="col-auto mt-4 mt-lg-5 pt-2">
                                    {/* Si el URL empieza con #, usar ScrollLink para scroll suave */}
                                    {botonUrl && botonUrl.startsWith('#') ? (
                                        <ScrollLink
                                            to={botonUrl.substring(1)} // Remover el #
                                            spy={true}
                                            smooth={true}
                                            duration={500}
                                            className="btn btn-primary"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {botonTexto}
                                        </ScrollLink>
                                    ) : (
                                        <RouterLink to={botonUrl || "#"} className="btn btn-primary">
                                            {botonTexto}
                                        </RouterLink>
                                    )}
                                </div>
                            ))}
                            {imagenOpcional && (
                                <div className="col-auto d-flex align-items-center">
                                    <img
                                        src={getPayloadMedia(imagenOpcional.url || imagenOpcional[0]?.url)}
                                        alt={imagenOpcional.alt || 'Imagen decorativa'}
                                        className="img-fluid"
                                        style={{maxWidth: '50%'}}
                                    />
                                </div>
                            )}
                            </div>
                        </div>
                        
                    </div>
                  
                </div>
            </Container>
        </section>
    );
}
